export const PRODUCT_SPECIFICATIONS_GET_ERROR = 'PRODUCT_SPECIFICATIONS_GET_ERROR';
export const PRODUCT_SPECIFICATIONS_GET_REQUEST = 'PRODUCT_SPECIFICATIONS_GET_REQUEST';
export const PRODUCT_SPECIFICATIONS_GET_SUCCESS = 'PRODUCT_SPECIFICATIONS_GET_SUCCESS';
